import styled, { css } from "styled-components";
import media from "constants/media";

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    cursor: pointer;
`;

export const Title = styled.div`
    opacity: 0.8;

    transition: opacity 0.2s ease-in-out;
`;

export const Icon = styled.div`
    display: flex;
    align-items: center;
    margin-left: 10px;

    ${({ chevronRight }) =>
        chevronRight &&
        css`
            transform: rotate(270deg);
        `}

    svg {
        width: 20px;

        transition: all 0.2s ease-in-out;
    }
`;

export const Content = styled.div`
    overflow: hidden;

    white-space: pre-wrap;

    opacity: 1;

    ${media.mdUp`
        opacity: 0;
        height: 0;
        visibility: hidden;
        transition: all 0.2s ease-in-out;
    `}
`;

export const ContainerBase = css`
    overflow: hidden;

    color: var(--color-darkNight);
    font-size: 14px;
    line-height: 20px;

    background-color: var(--color-athensGrey);

    ${({ active }) =>
        active &&
        css`
            ${Title} {
                opacity: 1;
            }

            ${Content} {
                height: auto;
                margin-top: 20px;
                visibility: visible;
                opacity: 1;
            }

            ${Icon} {
                svg {
                    transform: rotate(180deg);
                }
            }
        `}

    ${media.mdUp`
        font-size: 15px;
        line-height: 25px;
    `};
`;

export const ContainerBox = css`
    ${ContainerBase};

    margin: 10px 0;
    padding: 14px 20px;

    border: 1px solid rgba(0, 23, 75, 0.1);

    ${Header} {
        margin: -14px -20px;
        padding: 14px 20px;

        background-color: var(--color-athensGrey);
    }

    ${({ active }) =>
        active &&
        css`
            background-color: var(--color-white);

            ${Header} {
                background-color: var(--color-white);
            }
        `}
`;

export const ContainerMinimal = css`
    ${ContainerBase};

    padding: 28px 0 28px 10px;

    background-color: var(--color-white);
    border-top: 1px solid rgba(0, 23, 75, 0.1);

    :last-of-type {
        border-bottom: 1px solid rgba(0, 23, 75, 0.1);
    }

    ${Header} {
        margin: -28px 0 -28px -10px;
        padding: 28px 0 28px 10px;
    }
`;

export const Container = styled.div`
    ${({ variant }) =>
        (variant === "box" && ContainerBox) ||
        (variant === "minimal" && ContainerMinimal)}
`;
